import { selectSelectedCampaign } from '@store/CampaignReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { useAppSelector } from '@utils/hooks'
import { requiredRule, stringRule } from '@utils/rules'
import { Form, Input } from 'antd'
import { useEffect } from 'react'

const Update = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedCampaign())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  if (!item) {
    return <></>
  }

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="id"
        required
        rules={[requiredRule()]}
        style={{ display: 'none' }}
      >
        <Input type="hidden" />
      </Form.Item>
      <Form.Item
        name="name"
        label={'Nom'}
        rules={[requiredRule(), stringRule()]}
      >
        <Input />
      </Form.Item>
    </Form>
  )
}

export default Update
